import { z } from 'zod';

export const ComplexRoleSchema = z.object({
  id: z.string().or(z.number()), 
  name: z
    .string()
    .min(1, 'Название обязательно для заполнения')
    .max(100, 'Название не должно превышать 100 символов'),
  description: z
    .string()
    .max(300, 'Описание не должно превышать 300 символов')
    .optional()
    .or(z.literal('')),
  roleUIs: z.array(
    z.object({
      id: z.string().or(z.number()),
      name: z.string(),
      displayName: z.string().optional(),
    })
  )
});
